import styled from "styled-components";

const StyledQuestionCaption = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export default StyledQuestionCaption;
